// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609030934/js/" + chunkId + "." + {"44":"7b03165c","225":"5296f892","481":"af3e103b","486":"078984f4","770":"8d5ce604"}[chunkId] + ".0.34010139034029885.chunk.js";
};